import React from 'react';
import classnames from 'classnames';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import AppModal from '@/components/AppModal/AppModal';
import TheButton from '@/components/school-management/TheButton/TheButton';
import { LEVEL_CONTROL_DEFAULTS } from '@/school-management/utils/levelControl';
import classNames from './styles.module.scss';

interface ClassCreatedModalProps {
  show: boolean;
  addStudentsToNewGroup: boolean;
  onClose: () => void;
  isTeacher?: boolean;
  groupName?: string;
  placementTestRequired?: boolean;
}

const ClassCreatedModal: React.FC<ClassCreatedModalProps> = ({
  show,
  addStudentsToNewGroup,
  onClose,
  isTeacher = false,
  groupName,
  placementTestRequired = LEVEL_CONTROL_DEFAULTS.placementTestRequired,
}) => {
  const { t } = useAdminTranslation();

  if (!show) return null;
  const getTitle = () => {
    if (isTeacher) {
      return t('settings.add_teachers.teachers_added');
    }
    if (addStudentsToNewGroup) {
      return t('schoolsListPage.classCreated');
    }
    if (groupName) {
      return t('schoolsListPage.studentsCreatedInClass', { className: groupName });
    }
    return t('schoolsListPage.studentCreatedSuccessfully');
  };

  return (
    <AppModal show={show} type='fade'>
      <div className={classnames(classNames.modal, classNames.copyModal)}>
        <h2>{getTitle()}</h2>
        <span
          className={classNames.description}
          dangerouslySetInnerHTML={{
            __html:
              '   ' +
              (isTeacher
                ? t('settings.add_teachers.success_description').toString()
                : t(
                    placementTestRequired
                      ? 'settings.add_students.classCreatedDescription'
                      : 'settings.add_students.classCreatedDescriptionNoLevelTest'
                  ).toString()),
          }}
        />
        <TheButton
          className={classNames.btn}
          text={t('done')}
          shouldRecolor={false}
          emitOnClick={onClose}
        />
      </div>
    </AppModal>
  );
};

export default ClassCreatedModal;
